/* Variante C — galeria sem scroll livre: muda por setas, miniaturas, teclado ou gesto de deslizar */
(function(){
  var g = null, sx = 0, sy = 0;
  document.addEventListener('pointerdown', function(e){
    if (e.button > 0) return;
    if (e.target.closest && e.target.closest('button,a')) { g = null; return; }
    g = e.target.closest ? e.target.closest('[data-fs-gallery]') : null;
    sx = e.clientX; sy = e.clientY;
  }, {passive:true});
  function end(e){
    if (!g) return;
    var gg = g; g = null;
    var dx = e.clientX - sx, dy = e.clientY - sy;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3){
      var b = gg.querySelector(dx < 0 ? '[data-next]' : '[data-prev]');
      if (b) b.click();
    }
  }
  document.addEventListener('pointerup', end, {passive:true});
  document.addEventListener('pointercancel', function(){ g = null; }, {passive:true});
  document.addEventListener('dragstart', function(e){ if (e.target.closest && e.target.closest('[data-fs-gallery]')) e.preventDefault(); });
})();

/* Variante C — luz que segue o rato nos cartões */
(function(){
  if (window.matchMedia('(hover: none)').matches) return;
  var sel = '.fs-card__stage,.at-car__stage,.fs-fam__img';
  var raf = 0, last = null, ev = null;
  document.addEventListener('pointermove', function(e){
    ev = e;
    if (raf) return;
    raf = requestAnimationFrame(function(){
      raf = 0;
      var t = ev.target && ev.target.closest ? ev.target.closest('.fs-card,.at-car,.fs-fam__item') : null;
      var st = t ? t.querySelector(sel) : null;
      if (last && last !== st){ last.style.removeProperty('--mx'); last.style.removeProperty('--my'); }
      last = st;
      if (!st) return;
      var r = st.getBoundingClientRect();
      st.style.setProperty('--mx', ((ev.clientX - r.left)/r.width*100).toFixed(1) + '%');
      st.style.setProperty('--my', ((ev.clientY - r.top)/r.height*100).toFixed(1) + '%');
    });
  }, {passive:true});
})();

/* Variante C — prazos de entrega:
   carros acima de 30 kg seguem por outra transportadora (48–72h), exceto os modelos em HEAVY_EXCEPT;
   Açores e Madeira: barco semanal à sexta-feira a partir de Leixões (tabela ALCOTRANS). */
(function(){
  var HEAVY_KG = 30, HEAVY_EXCEPT = ['range rover sv', 'grow'];
  var ISLANDS = [
    ['Madeira', 3, 6, 7], ['Porto Santo', 3, 10, 10], ['São Miguel', 3, 4, 5], ['Terceira', 2, 8, 9],
    ['Faial', 2, 10, 12], ['Pico', 2, 10, 12], ['São Jorge', 3, 15, 15], ['Graciosa', 2, 15, 15],
    ['Santa Maria', 3, 20, 20], ['Flores', 3, 20, 20], ['Corvo', 3, 20, 20]
  ];
  var ES = (document.documentElement.lang || 'pt').slice(0,2) === 'es';
  var WD = ES ? ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'] : ['domingo','segunda','terça','quarta','quinta','sexta','sábado'];
  var MO = ES ? ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'] : ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function now(){
    var p = {};
    new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Lisbon', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', weekday:'short', hour12:false}).formatToParts(new Date()).forEach(function(x){ p[x.type] = x.value; });
    return {y:+p.year, m:+p.month, d:+p.day, h:(+p.hour)%24, mi:+p.minute, s:+p.second, w:{Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6}[p.weekday]};
  }
  function day(p, add){ return new Date(Date.UTC(p.y, p.m-1, p.d + add)); }
  function label(t){ return WD[t.getUTCDay()] + ', ' + t.getUTCDate() + ' ' + MO[t.getUTCMonth()]; }
  function maxDays(w, h){ switch(w){ case 1: return h<15?2:3; case 2: return h<15?2:4; case 3: return 5; case 4: return h<15?4:5; case 5: return h<15?4:5; case 6: return 4; default: return 3; } }
  function cutoff(p){ return (p.w===1||p.w===2||p.w===4||p.w===5) && p.h < 15; }
  function isHeavy(title, grams){
    if (!(grams > HEAVY_KG*1000)) return false;
    var t = (title || '').toLowerCase();
    return !HEAVY_EXCEPT.some(function(x){ return t.indexOf(x) > -1; });
  }

  /* Prazo: este código passa a escrever o texto das caixas em stock (substitui o do fs.js) */
  var cache = {};
  function info(url){
    if (!cache[url]) cache[url] = fetch(url, {credentials:'same-origin'}).then(function(r){ return r.json(); }).catch(function(){ return null; });
    return cache[url];
  }
  function claim(box){
    box._pr = 1;
    var old = box.querySelector('[data-fs-delivery-text]'); if (!old) return;
    var fresh = old.cloneNode(true); old.parentNode.replaceChild(fresh, old);
    box._heavy = box.getAttribute('data-heavy') === 'true';
    var cart = box.closest('[data-fs-cart]');
    var url = cart ? '/cart.js' : (location.pathname.replace(/\/$/, '') + '.js');
    info(url).then(function(j){
      if (!j) return;
      if (cart) box._heavy = (j.items || []).some(function(it){ return isHeavy(it.product_title || it.title, it.grams); });
      else {
        var v = (j.variants || [])[0], sel = document.querySelector('[name="id"]');
        if (sel && j.variants) j.variants.forEach(function(x){ if (String(x.id) === String(sel.value)) v = x; });
        box._heavy = isHeavy(j.title, v ? v.weight : 0);
      }
      box.setAttribute('data-heavy', box._heavy ? 'true' : 'false');
      draw();
    });
  }
  function draw(){
    var p = now();
    document.querySelectorAll('[data-fs-delivery][data-mode="stock"]').forEach(function(box){
      if (!box._dv) return;
      if (!box._pr) claim(box);
      var out = box.querySelector('[data-fs-delivery-text]'); if (!out) return;
      var d2 = maxDays(p.w, p.h), d1 = d2 - 1;
      if (box._heavy){ d1 += 1; d2 += 1; }
      var w1 = day(p, d1).getUTCDay(), w2 = day(p, d2).getUTCDay();
      if (w1 === 0) d1 -= 2; else if (w1 === 6) d1 -= 1;
      if (w2 === 6) d2 += 2; else if (w2 === 0) d2 += 1;
      var html = (ES ? 'Recíbalo entre el <b>' : 'Recebe entre <b>') + label(day(p, d1)) + '</b> ' + (ES ? 'y el' : 'e') + ' <b>' + label(day(p, d2)) + '</b>';
      if (cutoff(p)){
        var sec = 15*3600 - (p.h*3600 + p.mi*60 + p.s), hh = Math.floor(sec/3600), mm = Math.floor(sec%3600/60), ss = sec%60;
        html += (ES ? ' si lo pide en las próximas ' : ' se encomendar nas próximas ') + '<span class="fs-cut">' + (hh > 0 ? hh + 'h ' + pad(mm) + 'min' : mm + 'min ' + pad(ss) + 's') + '</span>';
      }
      html += '.';
      if (out.innerHTML !== html) out.innerHTML = html;
      if (!ES && !box._isl && box.parentNode){ box._isl = 1; box.insertAdjacentHTML('afterend', islandsHTML()); }
    });
  }

  /* Ilhas: a encomenda tem de estar feita até às 15h da véspera do fecho do barco (cut-off da ALCOTRANS) */
  function islandsHTML(){
    var opts = ISLANDS.map(function(r, i){ return '<option value="' + i + '">' + r[0] + '</option>'; }).join('');
    var rows = [['Madeira','Sexta-feira','6 a 7 dias'],['Porto Santo','Sexta-feira, via Madeira','10 dias'],['São Miguel','Sexta-feira','4 a 5 dias'],['Terceira','Sexta-feira','8 a 9 dias'],['Faial e Pico','Sexta-feira','10 a 12 dias'],['São Jorge','Sexta-feira, via São Miguel','15 dias'],['Graciosa','Sexta-feira, via Terceira','15 dias'],['Santa Maria, Flores e Corvo','Sexta-feira, via São Miguel','20 dias']]
      .map(function(r){ return '<tr><td>' + r[0] + '</td><td>' + r[1] + '</td><td>' + r[2] + '</td></tr>'; }).join('');
    return '<details class="fs-isl" data-fs-isl><summary><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 17c2 0 2-1.5 4.5-1.5S10 17 12 17s2-1.5 4.5-1.5S19 17 21 17"/><path d="M3 20.5c2 0 2-1.5 4.5-1.5S10 20.5 12 20.5s2-1.5 4.5-1.5S19 20.5 21 20.5"/><path d="M6 13.5 7.5 9h9l1.5 4.5M12 9V3l5 3.5-5 1"/></svg><span>Açores ou Madeira? Ver prazo de entrega</span><i aria-hidden="true"></i></summary>'
      + '<div class="fs-isl__body"><select class="fs-input fs-isl__sel" data-fs-isl-sel aria-label="Ilha de destino"><option value="">Escolha a ilha de destino</option>' + opts + '</select>'
      + '<p class="fs-isl__out" data-fs-isl-out hidden></p>'
      + '<table class="fs-isl__t"><thead><tr><th>Ilha</th><th>Barco</th><th>Viagem</th></tr></thead><tbody>' + rows + '</tbody></table>'
      + '<p class="fs-isl__note">Os carros seguem de barco a partir de Leixões, com uma saída por semana, à sexta-feira. A viagem conta a partir da saída do barco. Mau tempo, greves ou falta de espaço no navio podem atrasar a saída. Portes para as ilhas: 25 €.</p></div></details>';
  }
  function island(sel){
    var box = sel.closest('[data-fs-isl]'), out = box.querySelector('[data-fs-isl-out]'), r = ISLANDS[sel.value];
    if (!r){ out.hidden = true; return; }
    var c = r[1], t1 = r[2], t2 = r[3], p = now(), toFri = (5 - p.w + 7) % 7, f = toFri, dl = 0;
    for (var k = 0; k < 4; k++){
      f = toFri + 7*k; dl = f - (5 - c) - 1;
      if (dl > 0 || (dl === 0 && p.h < 15)) break;
    }
    var a1 = label(day(p, f + t1)), a2 = label(day(p, f + t2));
    out.innerHTML = 'Encomende até <b>' + label(day(p, dl)) + ', às 15h</b>, para seguir no barco de <b>' + label(day(p, f)) + '</b>. Chegada prevista à ilha: <b>' + (t1 === t2 ? a1 : a1 + ' a ' + a2) + '</b>.';
    out.hidden = false;
  }
  document.addEventListener('change', function(e){
    if (e.target.matches && e.target.matches('[data-fs-isl-sel]')) island(e.target);
    if (e.target.matches && e.target.matches('[name="id"]')) document.querySelectorAll('[data-fs-delivery]').forEach(function(b){ b._pr = 0; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ draw(); setInterval(draw, 1000); });
  else { draw(); setInterval(draw, 1000); }
})();

/* Variante C — contagem decrescente até à subida de preço dos veículos (cartões e página de produto) */
(function(){
  var CAMPAIGN = {name:'Os preços dos veículos sobem', name_es:'Los precios de los vehículos suben', end:'2026-10-18T23:59:59+01:00'};
  if (!(Date.parse(CAMPAIGN.end) > Date.now()) || !window.FS || !FS.initCountdown) return;
  var ES = (document.documentElement.lang || 'pt').slice(0,2) === 'es';
  var css = ''
    + '.pc-cd{margin-top:16px;padding:14px 16px;border:1px solid rgba(211,32,43,.45);background:linear-gradient(90deg,rgba(211,32,43,.14),rgba(211,32,43,.03));display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap}'
    + '.pc-cd__t{display:flex;align-items:center;gap:10px;font:500 10.5px/1.35 var(--f-m,ui-monospace,monospace);letter-spacing:.14em;text-transform:uppercase;color:#f3f4f5}'
    + '.pc-cd__t span{color:#a7adb4}'
    + '.pc-dot{flex:none;width:8px;height:8px;border-radius:50%;background:#d3202b;box-shadow:0 0 0 0 rgba(211,32,43,.7);animation:pcPulse 1.6s infinite}'
    + '@keyframes pcPulse{70%{box-shadow:0 0 0 8px rgba(211,32,43,0)}100%{box-shadow:0 0 0 0 rgba(211,32,43,0)}}'
    + '.pc-cd__c{display:flex;align-items:flex-start;gap:4px;font-family:var(--f-m,ui-monospace,monospace);font-variant-numeric:tabular-nums}'
    + '.pc-cd__u{display:grid;justify-items:center;min-width:40px}'
    + '.pc-cd__u b{font-weight:400;font-size:24px;line-height:1;color:#fff}'
    + '.pc-cd__u small{margin-top:5px;font-size:9px;letter-spacing:.16em;text-transform:uppercase;color:#6c737b}'
    + '.pc-cd__s{font-size:20px;line-height:1;color:#d3202b;padding-top:1px}'
    + '.pc-cdc{position:absolute;left:10px;bottom:10px;z-index:4;display:inline-flex;align-items:center;gap:7px;padding:6px 9px;background:rgba(10,11,13,.86);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);color:#f3f4f5;font:500 10.5px/1 var(--f-m,ui-monospace,monospace);letter-spacing:.06em;font-variant-numeric:tabular-nums;pointer-events:none}'
    + '.pc-cdc .pc-dot{width:6px;height:6px}'
    + '.pc-cdc b{font-weight:500}'
    + '@media (max-width:749px){.pc-cd__u{min-width:34px}.pc-cd__u b{font-size:20px}.pc-cdc{left:6px;bottom:6px;padding:5px 7px;font-size:9.5px;gap:5px}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var name = ES ? CAMPAIGN.name_es : CAMPAIGN.name;
  function u(attr, lbl){ return '<span class="pc-cd__u"><b ' + attr + '>00</b><small>' + lbl + '</small></span>'; }
  function scan(){
    var price = document.querySelector('.fs-model .fs-price--xl');
    if (price && !price._pc && document.querySelector('.fs-model .fs-plate, .fs-model .fs-ex')){
      price._pc = 1;
      var box = document.createElement('div');
      box.className = 'pc-cd'; box.setAttribute('data-fs-cd', ''); box.setAttribute('data-end', CAMPAIGN.end); box.setAttribute('role', 'timer');
      box.innerHTML = '<div class="pc-cd__t"><i class="pc-dot"></i><div>' + name + '<br><span>' + (ES ? 'Precio actual solo durante' : 'Preço atual só durante') + '</span></div></div>'
        + '<div class="pc-cd__c">' + u('data-d', ES ? 'días' : 'dias') + '<span class="pc-cd__s">:</span>' + u('data-h', 'h') + '<span class="pc-cd__s">:</span>' + u('data-m', 'min') + '<span class="pc-cd__s">:</span>' + u('data-s', 's') + '</div>';
      var anchor = price.parentNode.querySelector('.fs-paylater') || price;
      anchor.parentNode.insertBefore(box, anchor.nextSibling);
      FS.initCountdown(box);
    }
    document.querySelectorAll('.fs-card').forEach(function(c){
      if (c._pc) return; c._pc = 1;
      var stage = c.querySelector('.fs-card__stage');
      if (!stage || !c.querySelector('.fs-tag--red')) return;
      var b = document.createElement('span');
      b.className = 'pc-cdc'; b.setAttribute('data-fs-cd', ''); b.setAttribute('data-end', CAMPAIGN.end);
      b.innerHTML = '<i class="pc-dot"></i><span>' + (ES ? 'Sube en ' : 'Sobe em ') + '<b data-d>00</b>d <b data-h>00</b>:<b data-m>00</b>:<b data-s>00</b></span>';
      stage.appendChild(b);
      FS.initCountdown(b);
    });
  }
  scan(); setInterval(scan, 1500);
})();
